import React, { useEffect } from "react";
import AboutSecetion from "../../components/aboutSection/AboutSecetion";
import DecauseWeCam from "../../components/decauseWeCan/DecauseWeCam";
import MissionSection from "../../components/missionSection/MissionSection";

const AboutUs = () => {
  const breadCrumbArray = [
    {
      id: 1,
      title: "Home",
      link: "/",
      active: false,
    },
    {
      id: 2,
      title: "About",
      link: "/about-us",
      active: true,
    },
  ];
  useEffect(() => {
    document.title = "About us";
  }, []);
  return (
    <div className="about_us py-10">
      {/* <BreadCrumb title="About Us" breadCrumbArray={breadCrumbArray} /> */}
      <AboutSecetion />
      <MissionSection />
      <DecauseWeCam />
      {/* <MeetOurTeam/> */}
      {/* <QuestionSection /> */}
      {/* <BecomeYoutuber/> */}
      {/* <div className="pb-12 sm:pb-20">
        <Feature />
      </div> */}
    </div>
  );
};

export default AboutUs;
